import * as React from 'react';
import X from 'assets/x.inline.svg';
import { useDispatch } from 'react-redux';
import { closeAdBar } from 'core/redux/adBar/actions';
import { useIntl } from 'react-intl';
import * as styles from './AdBar.module.scss';

export default function AdBar({ children }: React.PropsWithChildren<unknown>) {
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(closeAdBar());
    };
    const { formatMessage } = useIntl();

    return (
        <aside className={styles.root} aria-label="ad bar">
            <div className={styles.container}>
                {children}
                <button
                    onClick={handleClick}
                    type="button"
                    className={styles.close}
                >
                    <span className="sr-only">
                        {formatMessage({ id: 'adbar.close' })}
                    </span>
                    <X
                        role="img"
                        aria-label={formatMessage({ id: 'adbar.closeIcon' })}
                    />
                </button>
            </div>
        </aside>
    );
}
